import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { ResetPasswordRequestSchema } from '../client-sdk/api';

export const useSetNewPasswordApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createNewPassword = useCallback(
    async (data: ResetPasswordRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.resetPassword(data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createNewPassword,

    loading,
    error,
  };
};
